export const TEST_MODE =
  window.location.hostname === "localhost" ||
  window.location.hostname.startsWith("192.168.") ||
  window.location.hostname.startsWith("10.");

export const API_SERVER = "devf.securebet.xyz";
export const SITE_KEY = "6LdFOfMpAAAAAPvA5gKu67QgmlU5ScIop0LHLI-8";
export const DEBUG = false;

//var

export const MOBILE_SIZE = 670;
export const EXTRA_SMALL = 576;
export const SIZE_TABLET = 780;
export const SIZE_LSM = 950;
export const SIZE_SMALL_DESKTOP = 1024;
export const SIZE_MENU_ABSOLUTE = 1220;
export const SIZE_BIG_DESKTOP = 1540;
export const SIZE_2K = 2048;
export const SIZE_4K = 4096;

// common
export const ENUM_MODE_GAME = {
  real: "real",
  demo: "demo"
};

export const ENUM_BOT_THEME = {
  telegram: "telegram"
};

export const ENUM_MADE_ON = {
  tgBot: "bot",
  site: "site"
};

export const ENUM_GAME_TYPE = {
  lobby: "lobby",
  hit: "hit",
  live: "live",
  history: "history",
  favorites: "favorites",
  bonus: "bonus"
};

export const ENUM_LOGIN = {
  login: "login",
  register: "register"
};

export const checkUrlBotTg = () => window.location.search.search("bot_theme=telegram") >= 0;

// deviceSize

export const EnumDeviceModes = {
  mobile: "mobile",
  desktop: "desktop"
};
export const ENUM_DEVICE_ORIENTATION = {
  portrait: "portrait",
  landscape: "landscape"
};

//  user

export const ENUM_CURRENCY = {
  USDT: "USDT",
  RUB: "RUB",
  EUR: "EUR",
  UZS: "UZS",
  AZN: "AZN",
  ETB: "ETB",
  INR: "INR",
  BRL: "BRL"
};

export const ENUM_LANG = {
  ru: "ru",
  en: "en",
  hi: "hi"
};

export const ENUM_ACCOUNT_REGISTER = {
  email: "email",
  telegram: "telegram",
  admin: "admin",
  noRegister: "no_register"
};

// site

export const ENUM_BALANCE_TYPE = {
  fiat: "fiat",
  crypto: "crypto"
};

// other
const ONE_PORTION = 6;
export const GAME_COUNT = ONE_PORTION * 5;
export const BONUS_PROVIDER_NAME = "HyperSlot";

// local storage

export const ENUM_LCS_NAME = {
  alreadyAccount: "alreadyAccount",
  startR: "start_r",
  pbParams: "pb_params",
  casinoInfo: "casinoInfo",
  favoritesId: "favoritesId",
  saveGame: "saveGame",
  history: "history",
  userId: "userId",
  lang: "lang",
  isFortune: "isFurtune",
  categories: "categories"
};

export const ENUM_TOAST_TYPE = {
  success: "success",
  error: "error",
  info: "info"
};

export const ENUM_USER_ACTIVE = {
  any: "any",
  wait: "wait",
  activated: "activated",
  disabled: "disabled",
  accrued: "accrued"
};

export const ENUM_STATUS_FOR_USER = {
  enabled: "enabled", // пакет значений доступен для начисления;
  disabled: "disabled", //пакет значений недоступен для начисления;
  wait: "wait", // пакет значений ожидает отыгрыша бонуса, назначенного по предыдущему
  wagerAmount: "wagerAmount", //  сумма ставок, необходимая для отыгрыша бонуса;
  waitWeekDay: "waitWeekDay", //  сумма ставок, необходимая для отыгрыша бонуса;
  accrued: "accrued", // бонус по текущему пакету значений уже начислен;
  wagered: "wagered", // бонус по текущему пакету значений уже отыгран.
  expired: "expired" // бонус истёк.
};

export const ENUM_CASHBACK_STATUS = {
  enabled: "enabled",
  waitActivate: "waitActivate",
  waitWeekDay: "waitWeekDay",
  waitWelcome: "waitWelcome"
};

export const ENUM_WELCOME_USER_STATUS = {
  enabled: "enabled",
  disabled: "disabled",
  wait: "wait",
  accrued: "accrued",
  expired: "expired",
  wagered: "wagered"
};

export const ENUM_PROMOTION_STATUS = {
  loading: "loading",
  error: "error"
};

export const ENUM_PAYOUT_TYPE = {
  card: "card",
  phone: "phone",
  acc: "acc",
  crypto: "crypto"
};

export const ENUM_SORT_TYPE = {
  name: "name",
  countGames: "countGames"
};

export const clientId = "1047547644189-6fhal9gcnarij89qeckn9fl4bl3rurii.apps.googleusercontent.com";

export const ENUM_STORE_STATUS = {
  idle: "idle",
  loading: "loading",
  succeeded: "succeeded",
  failed: "failed"
};

export const ENUM_PROMOTION_ID = {
  welcome: "welcome",
  cashback: "cashback",
  freespins: "freespins"
};

// кэш для сохранение казино инфо и коллекции в локалсторажд
// export const MINUTES_CASH = 30;
export const MINUTES_CASH = 0.01;

export const ENUM_DEPOSIT_STATUS = {
  any: "any",
  created: "created",
  paid: "paid",
  canceled: "canceled",
  expired: "expired",
  moderation: "moderation",
  paidout: "success",
  inprocess: "in process",
  refunded: "refunded",
  failed: "failed",
  unknown: "unknown"
};

export const LIVE_TYPE_GAME = [
  "live dealer",
  "roulette",
  "baccarat",
  "poker",
  "andar bahar",
  "dragon tiger",
  "sic bo",
  "teen patti",
  "card"
];

export const LIVE_PROVIDER_NAME = ["Ezugi", "Vivo"];

// TODO - заполнить
export const ENUM_ROUTER_URL = {};
